import styled from "styled-components"

const LineElementInfo = styled.div`
  display: flex;
  flex-direction: column;
`

export default LineElementInfo
